import {
    FontAwesomeIcon,
    FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome'
import { ThemeContext, ThemeType } from 'grommet'
import { normalizeColor } from 'grommet/utils'
import { useContext } from 'react'

export default function Icon({
    icon,
    color,
    size,
    testId = 'icon',
}: {
    icon: FontAwesomeIconProps['icon']
    color?: string
    size?: FontAwesomeIconProps['size']
    testId?: string
}) {
    const theme = useContext<ThemeType>(ThemeContext)
    return (
        <FontAwesomeIcon
            icon={icon}
            color={normalizeColor(color || 'brand', theme)}
            size={size}
            data-testid={testId}
        />
    )
}
